export const PROPS = {
  availableTranslationList: 'availableTranslationList',
  workspaceScrollPosition: 'workspaceScrollPosition',
  cognitoTokenLastRefreshAt: 'cognitoTokenLastRefreshAt',
  shouldSaveReminder: 'shouldSaveReminder',
  isAllCompaniesLoaded: 'isAllCompaniesLoaded',
};

const st = window.sessionStorage;

function getItem(key) {
  return st.getItem(key);
}

function setItem(key, value) {
  st.setItem(key, value);
  return getItem(key) === value.toString();
}

function removeItem(key) {
  st.removeItem(key);
  return getItem(key) === null;
}

// eslint-disable-next-line max-len

export function sessionST(p = PROPS) {
  const fields = Object.keys(p);
  const methods = (name) => ({
    get: () => getItem(name),
    set: (v) => setItem(name, v),
    remove: () => removeItem(name),
  });
  return fields.reduce((a, v) => Object.assign(a, { [v]: () => methods(PROPS[v]) }), {
    [fields[0]]: () => methods(PROPS[fields[0]]),
  });
}
